export type PortalOptionValueModel = {
  cache_key: number,
  id: number,
  node_name: string,
  node_properties?: any[],
  portal_option_id: number,
  subtitle?: string,
  title: string,
  value?: string,
}

export type PortalOptionValueRequestOptions = {}

const state = {
  id: null,
  node_name: '',
  node_properties: [],
  portal_option_id: undefined,
  subtitle: '',
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'node_name' },
  { key: 'portal_option_id' },
  { key: 'subtitle' },
  { key: 'title' },
  { key: 'value' },
]

export default state
